import { css, useTheme } from "@emotion/react";
import { useContext } from "react";

import cardComponentContext from "./cardComponentContext";
import Image from "./Image.jsx";
import parseStyle from "./parseStyle";
import useThemeProps from "./useThemeProps.jsx";

export default function CardMedia(props) {
  const theme = useTheme();
  props = useThemeProps({
    props,
    name: "CardMedia",
  });
  let { aspectRatio = 16 / 9, image, style, ...restProps } = props;
  const {
    mirrored,
    mediaColspan,
    mediaMinWidth = 25,
    mediaAspectRatio = aspectRatio,
    borderRadius,
    isColorSameAsContainer,
    isHorizontal,
    mediaBelow,
  } = useContext(cardComponentContext);
  if (!image) {
    return null;
  }

  const horizontalOrder = mirrored ? null : -1;
  const verticalOrder = mediaBelow ? null : -1;
  const order = isHorizontal ? horizontalOrder : verticalOrder;
  return (
    <div
      css={css`
        flex: ${mediaColspan} ${mediaColspan};
        min-width: ${isHorizontal ? theme.getLength(mediaMinWidth) : "100%"};
        isolation: isolate;
        aspect-ratio: ${mediaAspectRatio};
        order: ${order};
        overflow: hidden;
        z-index: -1;
        border-radius: ${isColorSameAsContainer
          ? theme.getLength(borderRadius)
          : null};
        ${parseStyle(style, theme)}
      `}
      {...restProps}
    >
      <Image
        css={css`
          object-fit: cover;
          width: 100%;
          height: 100%;
          transition: 500ms;
          @supports not selector(.wsui-card:has(.wsui-card-link)) {
            .wsui-card.wsui-is-interactive:hover &,
            .wsui-card:focus-within & {
              transform: scale(1.05);
            }
          }
          .wsui-card:has(.wsui-card-link.wsui-is-interactive:hover) &,
          .wsui-card:has(.wsui-card-link:focus-visible) & {
            transform: scale(1.05);
          }
        `}
        {...image}
        imgProps={{
          style: {
            minHeight: "100%",
          },
        }}
        hideCaption
      />
    </div>
  );
}
